import { Button } from "@progress/kendo-react-buttons";
import {
  Batch,
  BatchItem,
  FILE_STATES,
  useBatchAddListener,
  useBatchFinishListener,
  useItemErrorListener,
  useItemAbortListener,
  useUploady,
} from "@rpldy/uploady";
import { filter } from "lodash";
import { useState } from "react";
import UploadItem from "./UploadItem";

const UploadList = (props: any) => {
  const { processPending } = useUploady();
  const [items, setItems] = useState<Array<BatchItem>>([]);
  const [isFinished, setIsFinished] = useState(false);
  const [errorItems, setErrorItems] = useState<Array<BatchItem>>([]);

  const onUpload = () => {
    processPending();
  };

  useBatchAddListener((batch: Batch) => {
    setItems((items) => items.concat(batch.items));
    setIsFinished(false);
  });

  useBatchFinishListener((batch: Batch) => {
    const newItems = filter(items, (item: BatchItem) => {
      return item?.state === FILE_STATES.ERROR;
    });

    setItems(errorItems);
    setIsFinished(true);
  });

  useItemErrorListener((item: BatchItem) => {
    setErrorItems((errorItems) => errorItems.concat(item));
  });
  useItemAbortListener((item: BatchItem) => {
    setErrorItems((errorItems) => errorItems.concat(item));
  });

  return (
    <div style={{ marginLeft: "10px" }}>
      {items.length > 0 &&
        items.map((item: any) => <UploadItem key={item.id} item={item} />)}
      <br />{" "}
      {items.length && !isFinished ? (
        <Button
          fillMode="solid"
          size="large"
          themeColor="primary"
          onClick={() => {
            onUpload();
          }}
        >
          Upload
        </Button>
      ) : null}
    </div>
  );
};

export default UploadList;
